<template>
	<div v-if="row.contrato.status != 'suspenso'" class="dropdown">
		<div class="cnt-button" data-toggle="dropdown">
			<i v-if="!is_load" class="fa fa-ellipsis-v"></i>
			<i v-else class="fa fa-spinner fa-spin"></i>
		</div>

		<ul v-if="!is_load" class="dropdown-menu dropdown-menu-right">
			<li @click="openClient">
				<a>
					<i class="fa fa-id-card-o"></i>
					Cliente
				</a>
			</li>
			<li @click="openMdCnt">
				<a>
					<i class="fa fa-file-text-o"></i>
					Contrato
				</a>
			</li>

			<li v-if="row.forms.length != 0" class="divider"></li>
			<btn-load-smart-form
				v-for="(form, id) in row.forms"
				:key="id"
				:form="form"
				:selfRefs="$refs"
			/>

			<template v-if="is_mapeble">
				<li class="divider"></li>
				<li @click="$refs.mapRiscos.open()">
					<a>
						<i class="fa fa-file-text-o"></i>
						Map Risco
					</a>
				</li>
			</template>

			<li v-if="row.status != 2" class="divider"></li>

			<li v-if="row.status != 2" class="cnt-btn">
				<button
					v-if="row.status == 1"
					@click="toggleStatus(2)"
					class="btn btn-success btn-block"
				>
					<i class="fa fa-stop"></i>
					Finalizar Tarefa
				</button>
				<button
					v-else
					@click="toggleStatus(1)"
					class="btn btn-primary btn-block"
				>
					<i class="fa fa-play"></i>
					Iniciar Tarefa
				</button>
			</li>
		</ul>

		<map-riscos ref="mapRiscos" />
		<smart-forms ref="SmartForms" />
		<md-open-contract ref="mdOpenContract" />
		<md-open-client ref="mdOpenClient" disabled />
	</div>
</template>
<script>
	import mapRiscos from './actions-components/mapeamento-risco.vue';
	import SmartForms from './actions-components/smart-forms.vue';
	import mdOpenContract from '../../contracts/components/modal.vue';
	import mdOpenClient from '../../cadastros/customers/modal.vue';
	import BtnLoadSmartForm from './btnLoadSmartForm.vue';
	import toastr from 'toastr';
	import WBS from 'js/http';

	export default {
		data() {
			return {
				is_load: false,
			};
		},
		components: {
			mapRiscos,
			BtnLoadSmartForm,
			SmartForms,
			mdOpenContract,
			mdOpenClient,
		},
		inject: ['row', 'update'],
		computed: {
			is_mapeble() {
				// console.log(this.row.contrato)
				return (
					Array.isArray(this.row.contrato.mapeamento) &&
					this.row.contrato.mapeamento.length != 0
				);
			},
		},
		methods: {
			clone(obj) {
				return JSON.parse(JSON.stringify(obj));
			},
			openClient() {
				if (
					this.row &&
					(this.row.cnpj.client_data || this.row.cnpj.sst_dat)
				) {
					this.$refs.mdOpenClient.closeModal();

					this.$nextTick(() => {
						const clientData = this.clone(
							this.row.cnpj.client_data || this.row.cnpj.sst_dat
						);
						this.$refs.mdOpenClient.data = clientData;

						this.$nextTick(() => {
							$('#mdClientes').modal('show'); 
							console.log(
								'Modal de Cliente aberto com dados:',
								clientData
							);
						});
					});
				} else {
					console.warn('Dados do cliente não encontrados');
				}
			},
			openMdCnt() {
				if (this.row && this.row.contrato) {
					this.$refs.mdOpenContract.closeModal();
					this.$nextTick(() => {
						this.$refs.mdOpenContract.data = {
							...this.row.contrato,
						};
						this.$refs.mdOpenContract.obs =
							this.row.contrato.cod_proposta &&
							this.row.contrato.cod_proposta.obs
								? this.row.contrato.cod_proposta.obs
								: '';
						this.$nextTick(() => {
							$('#ModalContratos').modal('show');
							console.log(
								'Modal aberto com dados:',
								this.row.contrato
							);
						});
					});
				} else {
					console.warn('Contrato não encontrado');
				}
			},
			toggleStatus(status) {
				this.is_load = true;
				let sData = {
					status: status,
					cod: this.row.cod,
					cod_contrato: this.row.contrato.cod,
				};
				WBS.send('private-custom-toggleStatusOS', sData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Status alterado com sucesso!');
						this.update(() => (this.is_load = false));
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>
<style scoped>
	.dropdown-menu > li {
		cursor: pointer;
	}
	.dropdown > i {
		padding: 3px 8px;
		cursor: pointer;
	}
	.dropdown > .cnt-button {
		text-align: right;
		cursor: pointer;
	}
	.cnt-btn {
		margin: -5px 6px 0px 6px;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/actions.vue